// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_1eUNr","dangerous":"view-default_dangerous_2u7FU"};